import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function TrocarSenhaPage() {
  const { user, changePassword } = useAuth();
  const navigate = useNavigate();
  const forçada = user?.mustChangePassword;

  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);
  const [ok, setOk] = useState(false);

  const salvar = async () => {
    setErro('');
    if (novaSenha.length < 6) return setErro('A nova senha deve ter pelo menos 6 caracteres.');
    if (novaSenha !== confirmar) return setErro('As senhas não coincidem.');
    if (!forçada && !senhaAtual) return setErro('Informe a senha atual.');

    setLoading(true);
    try {
      await changePassword(forçada ? undefined : senhaAtual, novaSenha);
      setOk(true);
      setTimeout(() => navigate('/dashboard'), 1500);
    } catch (e) {
      setErro(e.response?.data?.error || 'Erro ao alterar senha.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--surface-1)] flex items-center justify-center p-4">
      <div className="bg-[var(--surface-2)] border border-[var(--surface-4)] rounded-2xl w-full max-w-sm shadow-2xl p-8 space-y-6">
        <div className="text-center">
          <div className="text-3xl mb-3">🔑</div>
          <h1 className="text-lg font-bold text-slate-100">
            {forçada ? 'Defina sua senha' : 'Alterar senha'}
          </h1>
          {forçada && (
            <p className="text-sm text-slate-400 mt-1">
              Seu acesso foi criado com uma senha temporária. Defina uma senha pessoal para continuar.
            </p>
          )}
        </div>

        <div className="space-y-4">
          {!forçada && (
            <div>
              <label className="block text-xs text-slate-400 mb-1">Senha atual</label>
              <input
                type="password"
                className="w-full bg-[var(--surface-3)] border border-[var(--surface-4)] rounded-lg px-3 py-2.5 text-sm text-slate-100 focus:outline-none focus:border-blue-500"
                value={senhaAtual}
                onChange={e => setSenhaAtual(e.target.value)}
                placeholder="••••••••"
              />
            </div>
          )}

          <div>
            <label className="block text-xs text-slate-400 mb-1">Nova senha</label>
            <input
              type="password"
              className="w-full bg-[var(--surface-3)] border border-[var(--surface-4)] rounded-lg px-3 py-2.5 text-sm text-slate-100 focus:outline-none focus:border-blue-500"
              value={novaSenha}
              onChange={e => setNovaSenha(e.target.value)}
              placeholder="Mínimo 6 caracteres"
            />
          </div>

          <div>
            <label className="block text-xs text-slate-400 mb-1">Confirmar nova senha</label>
            <input
              type="password"
              className="w-full bg-[var(--surface-3)] border border-[var(--surface-4)] rounded-lg px-3 py-2.5 text-sm text-slate-100 focus:outline-none focus:border-blue-500"
              value={confirmar}
              onChange={e => setConfirmar(e.target.value)}
              placeholder="••••••••"
              onKeyDown={e => e.key === 'Enter' && salvar()}
            />
          </div>

          {erro && <p className="text-red-400 text-xs">{erro}</p>}
          {ok && <p className="text-emerald-400 text-xs">Senha alterada! Redirecionando...</p>}
        </div>

        <button
          onClick={salvar}
          disabled={loading || ok}
          className="w-full py-2.5 rounded-lg font-medium text-sm bg-blue-600 hover:bg-blue-500 text-white disabled:opacity-50 transition-colors"
        >
          {loading ? 'Salvando...' : 'Salvar nova senha'}
        </button>

        {!forçada && (
          <button
            onClick={() => navigate(-1)}
            className="w-full text-center text-xs text-slate-500 hover:text-slate-300 transition-colors"
          >
            Cancelar
          </button>
        )}
      </div>
    </div>
  );
}
